import { render, staticRenderFns } from "./EventNotification.vue?vue&type=template&id=a23fa7ce&"
import script from "./EventNotification.vue?vue&type=script&lang=js&"
export * from "./EventNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports